// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid___7vYK","tabletRow":"styles_tabletRow__cf7h1","desktopRow":"styles_desktopRow___PI6a"};